import { render, staticRenderFns } from "./ItemListPlain.vue?vue&type=template&id=4110375a&scoped=true"
import script from "./ItemListPlain.vue?vue&type=script&lang=js"
export * from "./ItemListPlain.vue?vue&type=script&lang=js"
import style0 from "./ItemListPlain.vue?vue&type=style&index=0&id=4110375a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4110375a",
  null
  
)

export default component.exports